export class Substitution {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Substitution";
    this.lt_scene = "Substitution";
    this.u3_scene = "Substitution U3";
    this.data = [];
    this.page = 0;
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    this.options = options;
    if (options.subsGraphicType === 'lt') {
      this.scene = this.lt_scene
    } else if (options.subsGraphicType === 'u3') {
      this.scene = this.u3_scene
    }
    let rugby_type = "";
    this.data.push({
      name: "Shirt Number 1",
      value: {
        text:
          (rugby_type === "union"
            ? options.players[0]?.order
            : options.players[0]?.squad?.shirt_number) || "",
      },
    });
    this.data.push({
      name: "Position 1",
      value: {
        text: options.players[0]?.squad?.position || "",
      },
    });
    this.data.push({
      name: "First Name 1",
      value: {
        text: options.players[0]?.squad?.player.first_name || "",
      },
    });
    this.data.push({
      name: "Last Name 1",
      value: {
        text: options.players[0]?.squad?.player.last_name || "",
      },
    });
    this.data.push({
      name: "First Name Uppercase 1",
      value: {
        text: options.players[0]?.squad?.player.first_name_upper || "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase 1",
      value: {
        text: options.players[0]?.squad?.player.last_name_upper || "",
      },
    });
    this.data.push({
      name: "Full Name 1",
      value: {
        text:
          (options.players[0]?.squad?.player.first_name || "") +
          " " +
          (options.players[0]?.squad?.player.last_name || ""),
      },
    });
    this.data.push({
      name: "Shirt Number 2",
      value: {
        text:
          (rugby_type === "union"
            ? options.players[1]?.order
            : options.players[1]?.squad?.shirt_number) || "",
      },
    });
    this.data.push({
      name: "Position 2",
      value: {
        text: options.players[1]?.squad?.position || "",
      },
    });
    this.data.push({
      name: "First Name 2",
      value: {
        text: options.players[1]?.squad?.player.first_name || "",
      },
    });
    this.data.push({
      name: "Last Name 2",
      value: {
        text: options.players[1]?.squad?.player.last_name || "",
      },
    });
    this.data.push({
      name: "First Name Uppercase 2",
      value: {
        text: options.players[1]?.squad?.player.first_name_upper || "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase 2",
      value: {
        text: options.players[1]?.squad?.player.last_name_upper || "",
      },
    });
    this.data.push({
      name: "Full Name 2",
      value: {
        text:
          (options.players[1]?.squad?.player.first_name || "") +
          " " +
          (options.players[1]?.squad?.player.last_name || ""),
      },
    });
    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Type",
      value: {
        text:
          options.team?._id === options.game?.home_team?._id
            ? "home"
            : options.team?._id === options.game?.away_team?._id
            ? "away"
            : "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });
    this.data.push({
      name: "Team Code",
      value: {
        text: options.team?.code || "",
      },
    });
    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Team Third Badge",
      value: {
        image: "${user}" + options.team?.variables?.third_badge || "",
      },
    });
    let kit =
      options.team?._id === options.game?.home_team?._id
        ? options.game?.home_team_kit
        : options.game?.away_team_kit;

    this.data.push({
      name: "Team Kit BG Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Pattern Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_pattern"] || "",
      },
    });

    this.data.push({
      name: "Team Kit BG Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });

    this.data.push({
      name: "Team Kit Pattern Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_pattern"] || "",
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
    if (this.page === 0) {
      this.page = 1;
      this.preview({ options: this.options });
    } else {
      this.page = 0;
    }
  }
  animateOff({ options }) {
    this.onAir = false;
    this.page = 0;
    this.sendAnimateOff(this.scene, []);
  }
}
